import styled from 'config/theme';

export const LogoWrapper = styled.div`
  margin-top: 1rem;
  background: transparent;
  width: 150px;
  height: calc(100px - 1rem);
  padding: 5px;
`;
